import React from 'react'
import VideoList from './VideoList'
import Help from './Help'
import styles from './ScreenWelcome.module.scss'

const ScreenWelcome = ({ user = null, section, currentSection, setPiece }) => {
	if (!user) {
		return <div />
	}

	return (
		<div className="section-extra-wide">
			<div className="section">
				<div className={styles.greeting}>Hi, {user[0].Organization}</div>

				<p className={styles.intro}>
					All Call to Action speeches will be published to our Winners Gallery at anthemawards.com.
					Choose the winning project(s) below to upload your speech.
				</p>

				<div>
					{user.map((project, p) =>
						<div key={p} className={styles.project}>
							<div className={styles.upload} onClick={() => setPiece(project)}>
								<div className={styles.pieceTitle}>{project.PieceTitle}</div>
								{project.awards.map((award, a) =>
									<div key={a} className={styles.pieceAward}>
										<div className={styles.pieceAwardTitle}>
											{award.pv
												? `${award.AwardLevel} / Anthem Community Voice`
												: award.AwardLevel}
										</div>

										{award.MediaType} / {award.CategoryType} / {award.Category}
									</div>
								)}
							</div>

							<VideoList key={project.PiceID} pieceID={project.PieceID} />
						</div>
					)}
				</div>

				<Help />
			</div>
		</div>
	)
}
export default ScreenWelcome
